var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page",class:_vm.pageClass,attrs:{"data-color":_vm.backgroundColor}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-color":"#1E22AA"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dda9267","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GeneralViews/AuthLayout.vue
// module id = gL1n
// module chunks = 4